import gql from 'graphql-tag'
import {useQuery} from '@apollo/client'
import {useGetFiltersData} from './getFiltersData'

const personaOverviewQuery = gql`
  query personaOverview($filters: Filters, $persona: String!, $benefits: [BenefitEligibility]) {
    personaOverview(filters: $filters, persona: $persona, benefits: $benefits) {
      averageAge
      population
      adultCount
      demographics {
        name
        percentage
      }
      gender {
        name
        percentage
      }
    }
  }
`

export default function PersonaOverview() {
  const {filtersData, personaSidebarOpen, benefitsData} = useGetFiltersData()

  const {
    data: personaOverview,
    loading: loadingPersonaOverview,
    refetch: refetchPersonaOverview,
    error: errorLoadingPersonaOverview
  } = useQuery(personaOverviewQuery, {
    variables: {
      filters: filtersData,
      persona: personaSidebarOpen?.name,
      benefits: benefitsData[0]
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return {personaOverview, loadingPersonaOverview, refetchPersonaOverview, errorLoadingPersonaOverview}
}
